<!-- BSG-compliant venue item with keyboard accessibility -->
<ng-container *ngIf="venue">
	<!-- Converted div to button for proper keyboard accessibility -->
	<button
		[class.selected]="selected"
		(click)="selectVenue(venue)"
		(keydown.enter)="selectVenue(venue)"
		class="venue-item shadow-small bsg-venue-item"
		[attr.aria-pressed]="selected"
		[attr.aria-label]="'Select venue: ' + venue.name + ', ' + venue.street"
	>
		<ion-row class="top-row">
			<!-- Info icon button with keyboard accessibility -->
			<button
				class="info_icon bsg-info-button"
				(click)="openModal(venue); $event.stopPropagation()"
				(keydown.enter)="openModal(venue); $event.stopPropagation()"
				tabindex="0"
				[attr.aria-label]="'View details for ' + venue.name"
			>
				<ion-icon src="../../../assets/dean_and_david/info.svg" aria-hidden="true"> </ion-icon>
			</button>

			<ion-col size="12">
				<p class="name">{{ venue.name }}</p>
				<ion-row>
					<p class="address">
						{{ venue.street }} {{ venue.number }}, <br />
						{{ venue.postalCode }} {{ venue.city | langObservable | async }}
						<span *ngIf="distance" class="distance-block"><br />{{ distance }}km</span>
					</p>
				</ion-row>
			</ion-col>
		</ion-row>
	</button>
</ng-container>
